export const DOG_CARD_GRID_COLS_CLASS =
    "grid-cols-2 gap-grid-gap md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5";

export const DOG_CARD_GRID_CLASS = `grid ${DOG_CARD_GRID_COLS_CLASS}`;

export const RESULTS_SURFACE_CLASS =
    "-mt-2 md:-mt-6 rounded-t-2xl md:rounded-t-surface bg-true-white surface-rise";

export const SECONDARY_RAIL_CLASS =
    "flex touch-manipulation snap-x snap-mandatory gap-3 overflow-x-auto overflow-y-hidden overscroll-x-contain scrollbar-minimal pt-1 pb-3";

export const SECONDARY_RAIL_ITEM_CLASS =
    "w-[152px] shrink-0 snap-start md:w-[176px]";

export const DOG_CARD_PRESS_CLASS =
    "rounded-card transition-transform duration-150 ease-[cubic-bezier(0.25,1,0.5,1)] active:scale-[0.98] active:duration-100 has-[[data-save-button]:is(:hover,:active)]:scale-100 motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-labrador-yellow focus-visible:ring-offset-2";
